import { Box } from "@mui/system";
import { Appbar } from "./components/Appbar";
import Container from '@mui/material/Container';
import { HeroSection } from "./components/HeroSection";
import { Skills } from "./components/Skills";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { CssBaseline, Divider } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from "react";


function App() {
  const [darkMode, setDarkMode] = useState('light')

  const theme = createTheme({
    palette: {
      mode: darkMode === 'dark' ? 'dark':'light',
    },
  });

  return (
      <ThemeProvider theme={theme}>
        <Box>
          <CssBaseline />
          <Appbar mode={(newMode)=>setDarkMode(newMode)}/>
          <Container>
            <HeroSection/>
            <Skills/>
            <About />
            <Contact />
            <Divider sx={{mt:5}}/>
            <Footer />
          </Container>
        </Box>
      </ThemeProvider>
  );
}

export default App;
